import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { isFirstItem, isLastItem, tokens } from '@airtel/air-design-system';
import { StyleSheet, View } from 'react-native';
import { PackCardWidget } from '../../../../pack-card-widget';
import ComparePlanBenefitItemV2 from '../compare-benefit-item-v2/CompareBenefitItemV2';
import { getCompareBenefitListV2Styles } from './CompareBenefitListV2Styles';
var CompareBenefitListV2 = props => {
  var tableListData = props.tableListData,
    isFirstTable = props.isFirstTable,
    isLastTable = props.isLastTable,
    onUserAction = props.onUserAction;
  var _tokens$spacing = tokens.spacing,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_1 = _tokens$spacing.SPACING_1,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_16 = _tokens$spacing.SPACING_16;
  var compareBenefitListV2Style = getCompareBenefitListV2Styles();
  var renderRow = (tableRow, idx, islastRow) => {
    var isSingleColumn = (tableRow === null || tableRow === void 0 ? void 0 : tableRow.length) === 1;
    return tableRow === null || tableRow === void 0 ? void 0 : tableRow.map((tableItemData, idx2) => {
      var _a;
      var isLastCol = isLastItem(tableRow, idx2);
      var isFirstRow = isFirstItem(idx);
      var isFirstCol = isFirstItem(idx2);
      var style = [{
        borderLeftWidth: SPACING_0,
        borderTopWidth: SPACING_0,
        borderRightWidth: SPACING_1,
        borderBottomWidth: SPACING_1,
        marginTop: SPACING_0,
        marginBottom: SPACING_0,
        borderRadius: SPACING_0,
        paddingHorizontal: SPACING_12,
        paddingVertical: SPACING_16
      }];
      if (isFirstRow) {
        style = style.concat({
          borderTopWidth: SPACING_1
        });
        if (isFirstTable) {
          if (isFirstCol) {
            style = style.concat(Object.assign({
              borderTopLeftRadius: SPACING_16
            }, isSingleColumn && {
              borderTopRightRadius: SPACING_16
            }));
          } else if (isLastCol) {
            style = style.concat({
              borderTopRightRadius: SPACING_16
            });
          }
        }
      }
      if (isLastTable && islastRow) {
        if (isFirstCol) {
          style = style.concat(Object.assign({
            borderBottomLeftRadius: SPACING_16
          }, isSingleColumn && {
            borderBottomRightRadius: SPACING_16
          }));
        } else if (isLastCol) {
          style = style.concat({
            borderBottomRightRadius: SPACING_16
          });
        }
      }
      if (isFirstCol) {
        style = style.concat({
          borderLeftWidth: SPACING_1
        });
      }
      return _jsx(View, Object.assign({
        style: compareBenefitListV2Style.cellContainer
      }, {
        children: (tableItemData === null || tableItemData === void 0 ? void 0 : tableItemData.isHeader) ? _jsx(PackCardWidget, Object.assign({}, tableItemData === null || tableItemData === void 0 ? void 0 : tableItemData.headerData, {
          style: compareBenefitListV2Style.packcard,
          withRoundedBorder: false,
          cardStyle: Object.assign(Object.assign({}, StyleSheet.flatten(style)), (_a = tableItemData === null || tableItemData === void 0 ? void 0 : tableItemData.headerData) === null || _a === void 0 ? void 0 : _a.cardStyle),
          onUserAction: onUserAction
        }), idx) : _jsx(ComparePlanBenefitItemV2, Object.assign({
          style: [style, compareBenefitListV2Style.compareBenefitItem]
        }, tableItemData === null || tableItemData === void 0 ? void 0 : tableItemData.tableItem), "" + ('row_' + idx + '_col' + idx2))
      }));
    });
  };
  return (tableListData === null || tableListData === void 0 ? void 0 : tableListData.length) > 0 && _jsx(_Fragment, {
    children: tableListData === null || tableListData === void 0 ? void 0 : tableListData.map((tableRow, idx) => {
      var isLast = isLastItem(tableListData, idx);
      return _jsx(View, Object.assign({
        style: [compareBenefitListV2Style.tableRowWrapper]
      }, {
        children: renderRow(tableRow, idx, isLast)
      }));
    })
  });
};
export default CompareBenefitListV2;